export enum ApiResponseStatusEnum {
  // 正常終了ステータス
  SUCCESSFUL_STATUS = 200,
}
